<!-- Page Wrapper -->

<div id="wrapper">

    <app-sidebar> </app-sidebar>
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

            <app-topbar></app-topbar>
            <!-- Sidebar Toggle (Topbar) -->
            <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
                        <mat-icon>assignment_turned_in</mat-icon>
                    </button>

            <!-- Begin Page Content -->
            <div class="container-fluid">

                <!-- Page Heading -->
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
                    <a (click)="upload()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                        <mat-icon [@rotatedState]="state" style="position: absolute;">autorenew</mat-icon>
                        <span style="margin-left: 30px;">Refresh Analytics</span>
                    </a>
                </div>





                <!-- Content Row -->
                <div class="row">
                    <!-- Earnings (Monthly) Card Example -->
                    <div class="col-xl-2 col-md-6 mb-4">
                        <div class="card border-left-primary shadow h-100 py-2">
                            <div class="card-body">
                                <div class="row no-gutters align-items-center">
                                    <div class="col mr-2">
                                        <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                                            Active visitors </div>
                                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{visitors}}</div>
                                    </div>
                                    <div class="col-auto">
                                        <mat-icon>trending_up</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Earnings (Monthly) Card Example -->
                    <div class="col-xl-2 col-md-6 mb-4">
                        <div class="card border-bottom-secondary shadow h-100 py-2">
                            <div class="card-body">
                                <div class="row no-gutters align-items-center">
                                    <div class="col mr-2">
                                        <div class="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                                            Registered Students </div>
                                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{students}}</div>
                                    </div>
                                    <div class="col-auto">
                                        <mat-icon>person</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>





                    <!-- Pending Requests Card Example -->
                    <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card border-left-danger shadow h-100 py-2">
                            <div class="card-body">
                                <div class="row no-gutters align-items-center">
                                    <div class="col mr-2">
                                        <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                                            LoggedIn</div>
                                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{loggedIn}}</div>
                                    </div>
                                    <div class="col-auto">
                                        <mat-icon>login</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-xl-3 col-md-6 mb-4">
                        <div class="card border-bottom-secondary shadow h-100 py-2">
                            <div class="card-body">
                                <div class="row no-gutters align-items-center">
                                    <div class="col mr-2">
                                        <div class="text-xs font-weight-bold text-secondary text-uppercase mb-1">Survey Response ({{noOfSurvey}})
                                        </div>
                                        <div class="row no-gutters align-items-center">
                                            <div class="col-auto">
                                                <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">{{surveys+"%"}}</div>
                                            </div>
                                            <div class="col">
                                                <div class="progress progress-sm mr-2">
                                                    <div class="progress-bar bg-info" role="progressbar" [style]="widthStyle" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <mat-icon>poll</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <!-- Pending Requests Card Example -->
                    <div class="col-xl-2 col-md-6 mb-4">
                        <div class="card border-left-warning shadow h-100 py-2">
                            <div class="card-body">
                                <div class="row no-gutters align-items-center">
                                    <div class="col mr-2">
                                        <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                                            Videos Uploaded</div>
                                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{videos}}</div>
                                    </div>
                                    <div class="col-auto">
                                        <mat-icon>slideshow</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <!--------------------------------------------------------------------------Cards Stats------------------------------------------------------------------------->

                <div class="row">

                    <!-- Pie Chart -->
                    <div class="col-xl-4 col-lg-2">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-header py-4 d-flex flex-row align-items-center justify-content-between">
                                <h6 class="m-0 font-weight-bold text-primary">Campuses with most Students</h6>
                            </div>
                            <!-- Card Body -->
                            <div class="card-body" style="margin-bottom: 4%;">
                                <div class="chart-pie pt-4 pb-2">
                                    <canvas id="myPieChart"></canvas>

                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Area Chart -->
                    <div class="col-xl-8 col-lg-7">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 class="m-0 font-weight-bold text-primary">Logging In Overview ({{nowMonth}})</h6>
                            </div>
                            <!-- Card Body -->
                            <div class="card-body">
                                <div class="chart-area">
                                    <canvas id="myAreaChart" style="height: 0%;"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>





                <!-- Bootstrap core JavaScript-->
                <script src="vendor/jquery/jquery.min.js"></script>
                <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>

                <!-- Core plugin JavaScript-->
                <script src="vendor/jquery-easing/jquery.easing.min.js"></script>

                <!-- Custom scripts for all pages-->
                <script src="js/sb-admin-2.min.js"></script>

                <!-- Page level plugins -->
                <script src="vendor/chart.js/Chart.min.js"></script>

                <!-- Page level custom scripts -->
                <script src="js/demo/chart-area-demo.js"></script>
                <script src="js/demo/chart-pie-demo.js"></script>
            </div>
        </div>
    </div>
</div>